module.exports = __webpack_public_path__ + "img/logitricks_logo.833e2e05.png";